<template>
  <div id="main">
    <div
      v-for="(img, idx) in carouselImages"
      :key="idx"
      class="swiper-item"
      v-show="activeSwiperIndex === idx"
    >
      <img :src="img" alt="" class="carousel-img" />
      <div class="carousel-content">
        <h2 class="carousel-title">
          {{ $t("home_main_carousel_title") }}<br />
          {{ $t("home_main_carousel_title2") }}
        </h2>
        <div class="carousel-btns">
          <div class="join-btn" @click="scrollToSection('partner')">
            {{ $t("home_main_submit_btn") }}
          </div>
          <div class="download-btn" @click="scrollToSection('freedom')">
            {{ $t("home_main_download_btn") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryByDomain } from "@/common/config";

export default {
  name: "MainView",
  data() {
    return {
      activeSwiperIndex: 0,
      timer: null,
    };
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    carouselImages() {
      if (this.country === "uk") {
        return [
          require("@/assets/Keeta2/头图第一张@2x.png"),
          require("@/assets/Keeta2/头图第二张@2x.png"),
        ];
      } else {
        return [
          // require("@/assets/Keeta2/头图第一张@2x.png"),
          require("@/assets/Keeta2/头图第二张@2x.png"),
        ];
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.activeSwiperIndex =
        (this.activeSwiperIndex + 1) % this.carouselImages.length;
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    scrollToSection(sectionId) {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
#main {
  min-width: $min-width;
  height: 850px;
  position: relative;
}
.carousel-img {
  width: 100%;
  height: 850px;
  object-fit: cover;
}
.swiper-item {
  position: relative;
  width: 100%;
  height: 850px;
}
.carousel-content {
  position: absolute;
  left: 350px;
  bottom: 90px;
  color: #fff;
  z-index: 2;
}
.carousel-title {
  font-size: 2rem;
  margin-bottom: 32px;
  font-weight: 900;
  line-height: 100px;
  color: #ffffff;
  font-family: $title-font;
}
.carousel-btns {
  display: flex;
  justify-content: space-between;
  width: 534px;
  height: 70px;
  text-align: center;
  font-weight: 600;
  font-size: $font-size-base;
  font-family: $content-font;
}
.join-btn {
  width: 260px;
  background: #ffe41f;
  color: #222;
  border-radius: 75px;
  padding: 12px 0px;
  line-height: 46px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.download-btn {
  width: 260px;
  background: none;
  color: #ffffff;
  border-radius: 75px;
  border: 1px solid #ffffff;
  padding: 12px 0px;
  line-height: 46px;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-left: 30px;
}
.join-btn:hover,
.download-btn:hover {
  opacity: 0.7;
}
</style>
